import type { IBorderOuter } from '../BorderOuter'

import { COLOR } from 'vars/index'
import { BorderOuter } from '../BorderOuter'

export interface IBorderOuterLeftGradient extends IBorderOuter {}

export const BorderOuterLeftGradient = ({
  children,
  borders = [0, 0, 0, 4],
  borderColor,
  borderColorGradient = COLOR.ACCENT_PRIMARY_GRADIENT,
  corners,
}: IBorderOuterLeftGradient) => (
  <BorderOuter
    borders={borders}
    borderColor={borderColor}
    borderColorGradient={borderColorGradient}
    corners={corners}
  >
    {children}
  </BorderOuter>
)
